import { React, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ContactForm from "../Components/Contactform_rev"

//assets
import close_icon from "../images/close_icon.png"
import ChatusForm from "./ChatusForm";

function FormModal({ modal, active, property, form }) {


    const { pathname } = useLocation();
    const currentPath = pathname.split("/").filter(Boolean);

    // console.log(modal, currentPath);

    const primary_paths = [
        "/apartments-and-villas-for-sale-in-coimbatore",
        "/plots-for-sale-in-coimbatore",
        "/buy-house-in-coimbatore",
        "/office-space-for-rent-in-coimbatore",
        "/residential"
    ];

    if (modal === true) {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "unset";
    }
    console.log(property)


    return (
        <>
            <div className={modal === true ? "bg-black bg-opacity-70 inset-0 fixed z-50 w-full h-full flex flex-col items-center justify-center" : "hidden"} >
                <div className="bg-white px-5 py-4 rounded-lg relative w-[90%] max-w-md sm:max-w-lg lg:max-w-lg max-h-[90vh] p-6 sm:p-8 overflow-y-auto">
                    <img src={close_icon} alt="close_icon" className="w-[20px] h-[20px] sm:w-[20px] sm:h-[20px] absolute right-6 top-6 cursor-pointer z-50" onClick={() => { active() }} />

                    <div className={primary_paths.includes(pathname) ? "hidden" : "block"}>
                        <ContactForm />
                    </div>

                    <div className={primary_paths.includes(pathname) ? "block" : "hidden"}>
                        {primary_paths.includes(pathname) && form !== 3 ? 
                            <ContactForm property_name={property} formName={form} /> 
                            : <ChatusForm />}

                    </div>

                </div>
            </div>
        </>
    )
}

export default FormModal;